import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MainLayout from '../../layouts/MainLayout';
import './SmartDrill.css';
import './FourLines.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import NumbersByLanguage from './NumbersByLanguage';
import CountingNumbers from '../../assets/pageimages/CountingNumbers.webp';

function SmartDrillCounting() {
  const authState = useSelector(state => state.authReducer);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState('English'); // Default language1
  const [selectedLanguage2, setSelectedLanguage2] = useState('None'); // Default language2
  const [selectedMedium, setSelectedMedium] = useState('MADSmania Sheets'); // Default medium
  const [selectedPracticeWith, setSelectedPracticeWith] = useState('Solo'); // Default practiced with
  const [selectedMethod, setSelectedMethod] = useState('View'); // Default method
  const [selectedGroup, setSelectedGroup] = useState('1-100'); // Default group
  const [practiceData, setPracticeData] = useState([]);
  const [showNumbers, setShowNumbers] = useState(false); 
  
  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedTime(prevTime => prevTime + 1);
    }, 1000); 

    return () => clearInterval(interval);
  }, []);

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const languageList = [
    'Arabic', 'Assamese', 'Bangla', 'Burmese', 'Chinese', 'English', 'French', 'German', 'Gujarati', 'Hindi', 'Italian',
    'Javanese', 'Japanese', 'Kannada', 'Korean', 'Malayalam', 'Marathi', 'Odia', 'Polish', 'Portuguese',
    'Punjabi', 'Russian', 'Sinhala', 'Spanish', 'Tamil', 'Telugu', 'Thai', 'Turkish', 'Urdu', 'Vietnamese'
  ];

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  const language2List = [
    'Arabic', 'Assamese', 'Bangla', 'Burmese', 'Chinese', 'English', 'French', 'German', 'Gujarati', 'Hindi', 'Italian',
    'Javanese', 'Japanese', 'Kannada', 'Korean', 'Malayalam', 'Marathi', 'Odia', 'Polish', 'Portuguese',
    'Punjabi', 'Russian', 'Sinhala', 'Spanish', 'Tamil', 'Telugu', 'Thai', 'Turkish', 'Urdu', 'Vietnamese'
  ];

  const handleLanguage2Change = (language2) => {
    setSelectedLanguage2(language2);
  };

  const groupList = [
    "1-10", "10-20", "20-30", "30-40", "40-50", "50-60", "60-70", "70-80", "80-90", "90-100", "1-100", "1-50", "51-100"
  ];

  const handleGroupChange = (group) => {
    setSelectedGroup(group);
  };

  const methodList = [
    'View', 'Listen', 'By Heart'
  ];

  const handleMethodChange = (method) => {
    setSelectedMethod(method);
  };

  const mediumList = [
    'MADSmania Sheets', 'Paper / Notebook', 'By Heart', 'Others'
  ];

  const handleMediumChange = (medium) => {
    setSelectedMedium(medium);
  };

  const practicewithList = [
    'Solo', 'Mother', 'Teacher', 'Father', 'Brother', 'Sister', 'Friend', 'Relatives', 'Others'
  ];

  const handlePracticeWithChange = (practicewith) => {
    setSelectedPracticeWith(practicewith);
  };

  const handleShowNumbers = () => {
    setShowNumbers(true); 
  };

  const handleSavePractice = () => {
    // clearInterval(interval);
    // Calculate the end time and elapsed time
    const endTime = Date.now();
    const elapsedTimeMs = endTime - startTime;
    const elapsedTimeSeconds = elapsedTimeMs / 1000;

    // Calculate ecoPoints based on selectedMedium
    let ecoPoints = 0;
    if (selectedMedium === 'MADSmania Sheets') {
      ecoPoints = 25;
    } else if (selectedMedium === 'Paper / Notebook' || selectedMedium === 'By Heart') {
      ecoPoints = 5;
    } else {
      ecoPoints = 0;
    }

    // Create the data object
    const practiceData = {
      userId: authState.user.id,
      userName: authState.user.name,
      practiceLanguage: selectedLanguage,
      practiceLanguage2: selectedLanguage2,
      methodName: selectedMethod,
      mediumName: selectedMedium,
      groupName: selectedGroup,
      practicedWith: selectedPracticeWith,
      startTime: new Date(startTime),
      endTime: new Date(endTime),
      elapsedTimeMs,
      ecoPoints: ecoPoints,
      page: 'SMARTDrill Counting Numbers',
      dateCreated: new Date()
    };
    setPracticeData(prevData => [...prevData, practiceData]);
    setSaveButtonDisabled(true);
  };

  const handlePracticeAgain = () => {
    setMultiplicationTable([]);
    setError('');
    setNumber('');
    setFromNumber('');
    setToNumber('');
    setNumber1('');
    setNumber2('');
    setNumber3('');
    setShowTimer(false);
    setStartTime(null);
    setEndTime(null);
    setElapsedTimeMs(0);
    setSaveButtonDisabled(false);
    setPracticeData(prevData => {
      if (!prevData) return []; 
      return [...prevData, prevData]; 
    });
  };

  const handlePracticeOver = () => {
    // console.log('Practice Over');
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mb-2 mx-2 border-b border-b-gray-300 text-white'>SMARTDrill - Counting Numbers</h2>
      </div>
      <div className="mx-auto max-w-[760px]">
        <div className="flex justify-center mt-1 mb-1 ml-4 mr-4 relative">
          <img className="align-middle" src={CountingNumbers} alt="KidMotherImage" />
          <div className="timer-and-speaker absolute top-0 right-0 flex items-center">
            <span className="timer">{formatTime(elapsedTime)}</span>
            <FontAwesomeIcon icon={faVolumeUp} className="ml-2" />
          </div>
        </div>
        <div className="flex justify-center mb-1">
          <div className='ml-4'>
            <p className=' text-white'>1st Language</p>
            <select value={selectedLanguage} onChange={(e) => handleLanguageChange(e.target.value)} className="p-2">
              {languageList.map((language, index) => (
                <option key={index} value={language}>{language}</option>
              ))}
            </select>
          </div>
          <div className='ml-4'>
            <p className=' text-white'>Group</p>
            <select value={selectedGroup} onChange={(e) => handleGroupChange(e.target.value)} className="ml-2 p-2">
              {groupList.map((group, index) => (
                <option key={index} value={group}>{group}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-center mb-2">
          <div className='ml-4'>
            <p className=' text-white'>2nd Language</p>
            <select value={selectedLanguage2} onChange={(e) => handleLanguage2Change(e.target.value)} className="p-2">
              {language2List.map((language2, index) => (
                <option key={index} value={language2}>{language2}</option>
              ))}
            </select>
          </div>
          <div className='ml-4'>
            <p className=' text-white'>Practice Method</p>
            <select value={selectedMethod} onChange={(e) => handleMethodChange(e.target.value)} className="p-2 ml-2">
              {methodList.map((method, index) => (
                <option key={index} value={method}>{method}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-center mb-2">
          <div className='ml-4'>
            <p className='text-white'>Practice Medium</p>
            <select value={selectedMedium} onChange={(e) => handleMediumChange(e.target.value)} className="p-2 ml-2">
              {mediumList.map((medium, index) => (
                <option key={index} value={medium}>{medium}</option>
              ))}
            </select>
          </div>
          <div className='ml-4'>
            <p className='text-white'>Practicing With</p>
            <select value={selectedPracticeWith} onChange={(e) => handlePracticeWithChange(e.target.value)} className="p-2 ml-2">
              {practicewithList.map((practicewith, index) => (
                <option key={index} value={practicewith}>{practicewith}</option>
              ))}
            </select>
          </div>
        </div>
       
        <div className="mx-auto justify-center items-center max-w-[760px]">
          <button onClick={handleShowNumbers} className="ml-2 p-2 bg-blue-500 text-white">Show Numbers</button> 
          {showNumbers && ( 
          <div className="mx-auto justify-center items-center max-w-[760px]">
            <NumbersByLanguage language={selectedLanguage} /> 
          </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
}

export default SmartDrillCounting;
